import React, { Component } from 'react';
import { connect } from 'react-redux';
import SocialLogin from './SocialLogin';
import '../../../theme/form-style-label-animation.scss';
import { Form, Field } from 'react-final-form';
import GupshupWhatsapp from '../../../CommonComponents/GupshupWhatsapp';
import { setCurrentWhatsappStatus } from '../../../actionCreators/gupshupWhatsapp';
import { checkUserExists, changeUserExistsValue, sendCampaignUserData, firstDealUserExists } from '../../../actionCreators/offerCampaign';
import BannerPdpDetail from './BannerPdpDetail';
import './Register.scss';

/** isUserExists :
*   When user enter mobile number a call hit to check that if user alredy exist or not
*   This variable shows that.
*/

class Register extends Component {
    constructor(props, context) {
        super(props, context);
        const { openTab, redisCommonData } = this.props;
        let WHATSAPP_OPTIN = redisCommonData.WHATSAPP_OPTIN ? JSON.parse(redisCommonData.WHATSAPP_OPTIN) : {};
        WHATSAPP_OPTIN = WHATSAPP_OPTIN.Desktop.Register || {};
        this.inputPassword = React.createRef();
        this.state = {
            openTab,
            whatsappOptin: WHATSAPP_OPTIN,
            isUserOptInForWhatsapp: WHATSAPP_OPTIN.toggle === 'ON',
            showReferralInput: false
        };
        this.pageInfo = `page: ${document.location.pathname}${document.location.search}`;
        this.getCheckBoxStatus = this.getCheckBoxStatus.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { register, hideLogin, commonActions, registerError, setCurrentWhatsappStatus } = this.props;
        const { isUserOptInForWhatsapp } = this.state;
        if ((register && !prevProps.register)) {
            hideLogin();
            window.localStorage.setItem('reloadRequired', true);
            commonActions.getUserInfo();
            _gaq.push(['_trackEvent', 'SIGNUP POPUP', 'Register Success', this.pageInfo]);
            _gaq.push(['ninja._trackEvent', 'SIGNUP POPUP', 'Register Success', this.pageInfo]);
            setCurrentWhatsappStatus(isUserOptInForWhatsapp);
            if (window.prevUrl) window.history.back();
        }
        if (registerError === null && prevProps.registerError) {
            _gaq.push(['_trackEvent', 'SIGNUP POPUP', 'Register Failure', this.pageInfo]);
            _gaq.push(['ninja._trackEvent', 'SIGNUP POPUP', 'Register Failure', this.pageInfo]);
        }
    }

    componentWillUnmount() {
        // To hide userExist div below mobile number, by setting value null
        this.props.changeUserExistsValue(null);
    }

    onlyAlpa = value => {
        const { dataLocale } = this.props;
        const { THIS_IS_REQUIRED_FIELD, SPECIAL_CHARACTERS_NOT_ALLOWED } = dataLocale;
        let error;
        if (!value || !value.trim()) {
            error = THIS_IS_REQUIRED_FIELD;
        } else if (!/^[(a-zA-Z )]+$/.test(value)) {
            error = SPECIAL_CHARACTERS_NOT_ALLOWED;
        }
        return error;
    };
    onlyAlpaNotRequired = value => {
        const { dataLocale } = this.props;
        const { SPECIAL_CHARACTERS_NOT_ALLOWED } = dataLocale;
        let error;
        if ((!/^([^0-9]*).*(?=.*[a-zA-Z]).*$/.test(value)) || !(/^([^0-9]*)$/.test(value))) {
            error = SPECIAL_CHARACTERS_NOT_ALLOWED;
        }
        return error;
    };
    getInitialData = () => {
        const getReferralParam = (this.urlParam('ir_co') !== null && this.urlParam('ir_co') !== 0) ? this.urlParam('ir_co') : null;
        return {
            referalCode: getReferralParam
        };
    }

    getCheckBoxStatus(userWhatsappOptinStatus) {
        this.setState({ isUserOptInForWhatsapp: userWhatsappOptinStatus });
    }

    doRegister = data => {
        const { registerActions, localeInfo, selectedOffer, isOffer, sendCampaignUserData, login, userInfo, firstDealUserExists } = this.props;
        const { phoneCode } = localeInfo;
        // If Offer : Call for CampaignUserData
        if (isOffer) {
            const campaignUserData = {
                email: data.email || '',
                gender: data.gender || '',
                mobileNumber: data.mobile || '',
                name: `${data.firstName ? data.firstName : ''} ${data.lastName ? data.lastName : ''}`.trim(),
                category: selectedOffer && selectedOffer.cat_name || '',
            };
            if (login && userInfo && userInfo.result && userInfo.result.telephone) {
                campaignUserData.mobileNumber = userInfo.result.telephone;
            }
            sendCampaignUserData(campaignUserData);
            // Issue : new register, open offer modal, fill form
            // Due to false in isFirstDealUser key, unable to open success screen
            setTimeout(() => {
                if (login && userInfo && userInfo.result && userInfo.result.telephone) {
                    firstDealUserExists(userInfo.result.telephone);
                }
            }, 1000);
        }
        // Normal flow
        if (!login) {
            if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.loginPopup.load.loginPopupSignUpConfirm();
            data.phoneCode = phoneCode;
            registerActions.registerUser(data);
        }
    }

    urlParam(name) {
        const { location } = this.props;
        const results = new RegExp(`[\?&]${name}=([^&#]*)`).exec(location.search);
        if (results === null) {
            return null;
        }
        if (results !== null) {
            return results[1] || 0;
        }
    }

    handleRegister = value => {
        this.doRegister(value);
    }

    required = value => {
        const { dataLocale } = this.props;
        const { THIS_IS_REQUIRED_FIELD } = dataLocale;
        let error;
        if (!value || !value.trim()) {
            error = THIS_IS_REQUIRED_FIELD;
        }
        return error;
    };
    isValidMobile = value => {
        const { dataLocale, localeInfo } = this.props;
        const { THIS_IS_REQUIRED_FIELD, PLEASE_ENTER_VALID_MOBILE_NUMBER_EG } = dataLocale;
        let error;
        if (!value || !value.trim()) {
            error = THIS_IS_REQUIRED_FIELD;
        } else if ((!localeInfo.regex.test(value) && value !== localeInfo.mobileNumberLength)) {
            error = PLEASE_ENTER_VALID_MOBILE_NUMBER_EG;
        }
        return error;
    };
    isValidEmail = value => {
        const { dataLocale } = this.props;
        const { THIS_IS_REQUIRED_FIELD, PLEASE_ENTER_VALID_EMAIL_ADDRESS_EG } = dataLocale;
        let error;
        if (!value || !value.trim()) {
            error = THIS_IS_REQUIRED_FIELD;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            error = PLEASE_ENTER_VALID_EMAIL_ADDRESS_EG;
        }
        return error;
    };

    isValidPassword = value => {
        const { dataLocale } = this.props;
        const { THIS_IS_REQUIRED_FIELD, PASSWORD_SHOULD_BE_MORE_THAN } = dataLocale;
        let error;
        if (!value || !value.trim()) {
            error = THIS_IS_REQUIRED_FIELD;
        } else if (value.length < 6) {
            error = PASSWORD_SHOULD_BE_MORE_THAN;
        }
        return error;
    };

    render() {
        const { localeInfo, registerError, loading, dataLocale, isOffer, bannerImg, checkUserExists, isUserExists, showSignIn, hasPlacedOrder, login, productData, isDesktopPdp, productOfferDetails, redisCommonData: { BANNER_IMAGE } } = this.props;
        const { EMAIL_ADDRESS, FIRST_NAME, LAST_NAME, MOBILE, PASSWORD, OPTIONAL, REGISTER, CONTINUE, REFERRAL_CODE, BANNER, LOGO } = dataLocale;
        const { openTab, whatsappOptin, showReferralInput } = this.state;
        const { signUpUrl } = JSON.parse(BANNER_IMAGE);
        return (<div className="register-wrapper display-flex">
            <div className="auth-section_left-col">
                {isDesktopPdp ?
                    <BannerPdpDetail offerText={productOfferDetails && productOfferDetails.text1} dataLocale={dataLocale} productData={productData} /> :
                    <img
                        alt={BANNER}
                        src={bannerImg || signUpUrl}
                        className="res-img"
                        style={{ height: '100%' }}
                    />}
            </div>
            <div className="auth-section_right-col">
                <Form
                    onSubmit={this.handleRegister}
                    initialValues={this.getInitialData()}
                    validateOnBlur
                    render={
                        ({ handleSubmit, submitting }) =>
                        (
                            <form onSubmit={handleSubmit} name="register" className="form-SLA" noValidate>
                                <Field name="firstName" validate={this.onlyAlpa}>
                                    {({ input, meta }) => (
                                        <div className={`form-SLA_field-row ${meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''}`}>
                                            <input {...input} type="text" className={meta.valid || meta.error && meta.dirty ? 'form-SLA_field-row_label' : ''} autoComplete="firstName" />
                                            <label>{FIRST_NAME}</label>
                                            {meta.error && meta.touched && <span className="form-SLA_field-row_error">{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                <Field name="lastName" validate={this.onlyAlpaNotRequired}>
                                    {({ input, meta }) => (
                                        <div className={`form-SLA_field-row ${meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''}`}>
                                            <input {...input} type="text" className={meta.dirty ? 'form-SLA_field-row_label' : ''} autoComplete="lastName" />
                                            <label>{LAST_NAME}</label>
                                            {meta.error && meta.touched && <span className="form-SLA_field-row_error">{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                {/* Gender */}
                                {isOffer && <>
                                    <div className="margin-b15 labels">
                                        <Field
                                            validate={this.required}
                                            name="gender"
                                            component="input"
                                            type="radio"
                                            value="male"
                                        >
                                            {({ input }) => {
                                                return (<label>
                                                    <input
                                                        {...input}
                                                        name="gender"
                                                        type="radio"
                                                        value="male"
                                                    />
                                                    <span className="margin-l10">Male</span>
                                                </label>);
                                            }}
                                        </Field>
                                        <Field
                                            name="gender"
                                            component="input"
                                            type="radio"
                                            value="female"
                                        >
                                            {({ input }) => {
                                                return (<label>
                                                    <input
                                                        {...input}
                                                        name="gender"
                                                        type="radio"
                                                        value="female"
                                                    />
                                                    <span className="margin-l10">Female</span>
                                                </label>);
                                            }}
                                        </Field>
                                    </div>
                                    <Field name="gender">
                                        {({ meta }) => (
                                            meta.error && meta.touched ? <span style={{ marginTop: '-15px' }} className="form-SLA_field-row_error">{meta.error}</span> : <span></span>
                                        )}
                                    </Field>
                                </>
                                }
                                {!login && <Field name="mobile" validate={this.isValidMobile}>
                                    {({ input, meta }) => (
                                        <div className={`form-SLA_field-row ${meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''}`}>
                                        <div className="display-flex pos-rel">
                                            <input name="code" type="tel" autoComplete="code" title={localeInfo.phoneCode} placeholder={localeInfo.phoneCode} disabled="disabled" value={localeInfo.phoneCode} className="inline-block margin-r5 country-code-display-35 pos-abs fw-bold" style={{bottom: '7px'}} />
                                            <input
                                                {...input}
                                                onChange={e => {
                                                    input.onChange(e.target.value);
                                                    if (e.target.value.trim().length >= localeInfo.mobileNumberLength && isOffer) {
                                                        checkUserExists(e.target.value);
                                                    }
                                                }}
                                                minLength={localeInfo.mobileNumberLength}
                                                maxLength={localeInfo.mobileNumberLength}
                                                type="text"
                                                className={meta.valid || meta.error && meta.dirty ? 'form-SLA_field-row_label' : ''}
                                                autoComplete="mobile"
                                            />
                                            <label>{MOBILE}</label>
                                            </div>
                                            {meta.error && meta.touched && <span className="form-SLA_field-row_error">{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>}
                                {isUserExists && !hasPlacedOrder && !login && (
                                    <div className="user-exists-container mr-b15">
                                        <div className="display-flex justify-space-between align-items-center pd-t12 pd-b12 pd-r15 pd-l15 bora-4">
                                            <div className="fsp15 flex-basis-64 lh-22 text-cool_grey">
                                                Oops! You already have an account with us.
                                            </div>
                                            <span
                                                className="fsp14 text-topaz text-uppercase fw500 cursor-pointer"
                                                onClick={() => showSignIn()}
                                            >
                                                Sign In
                                            </span>
                                        </div>
                                    </div>
                                )}
                                <Field name="email" validate={this.isValidEmail}>
                                    {({ input, meta }) => (
                                        <div className={`form-SLA_field-row ${meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''}`}>
                                            <input {...input} type="email" className={meta.valid || meta.error && meta.dirty ? 'form-SLA_field-row_label' : ''} autoComplete="email" />
                                            <label>{EMAIL_ADDRESS}</label>
                                            {meta.error && meta.touched && <span className="form-SLA_field-row_error">{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>
                                {!login && <Field name="password" validate={this.isValidPassword}>
                                    {({ input, meta }) => (
                                        <div className={`form-SLA_field-row ${meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''}`}>
                                            <input {...input} type="password" className={meta.valid || meta.error && meta.dirty ? 'form-SLA_field-row_label' : ''} autoComplete="password" ref={this.inputPassword} />
                                            <label>{PASSWORD}</label>
                                            <div className="row-left checkbox show-password">
                                                <input type="checkbox" name="show_password" id="show_password" />
                                                <label
                                                    htmlFor="show_password"
                                                    onClick={
                                                        () => {
                                                            if (this.inputPassword.current.type === 'password') {
                                                                this.inputPassword.current.type = 'text';
                                                            } else {
                                                                this.inputPassword.current.type = 'password';
                                                            }
                                                        }
                                                    }
                                                >
                                                    <span></span>
                                                </label>
                                            </div>
                                            {meta.error && meta.touched && <span className="form-SLA_field-row_error">{meta.error}</span>}
                                        </div>
                                    )}
                                </Field>}
                                {!login && <>
                                    {!showReferralInput && <div className="margin-b18">
                                        <a
                                            className="fs-11 fw400"
                                            href=""
                                            onClick={e => {
                                                e.preventDefault();
                                                this.setState({ showReferralInput: true });
                                            }}
                                        >Got a Referral Code?</a>
                                    </div>}
                                    {showReferralInput && <Field name="referalCode">
                                        {({ input, meta }) => (
                                            <div className={`referal-code-section form-SLA_field-row ${meta.invalid && meta.touched ? 'form-SLA_field-row_invalid' : ''}`}>
                                                <input {...input} type="text" className="form-SLA_field-row_label" ref="referalCode" autoComplete="referalCode" placeholder={REFERRAL_CODE} />
                                                <span className="referal-optinal">({OPTIONAL})</span>
                                            </div>
                                        )}
                                    </Field>}
                                </>}

                                <div className="buttons text-center">
                                    {
                                        !loading ?
                                            <button type="submit" className={`form-SLA_field-row_submit ${isUserExists && 'disabled-register'}`} disabled={isUserExists || submitting}>{isOffer && login ? CONTINUE : REGISTER}</button>
                                            : <img src="//static.lenskart.com/skin/frontend/base/default/images/loader2.gif" alt={LOGO} />
                                    }
                                </div>

                                {registerError && <div className="alert alert-danger">
                                    {registerError && registerError.message}
                                </div>}
                                {!login && whatsappOptin.showWidget && <GupshupWhatsapp WHATSAPP_OPTIN={whatsappOptin} page="Desktop-Register" checkBoxStatus={this.getCheckBoxStatus} />}
                                {!login && <SocialLogin {...this.props} loginValue={openTab} />}
                            </form>
                        )}
                />
            </div>
        </div >);
    }
}

const mapStateToProps = state => ({
    localeInfo: state.common.localeInfo,
    isUserExists: state.offerCampaign.isUserExists,
});

const mapDispatchToProps = dispatch => {
    return {
        setCurrentWhatsappStatus: status => dispatch(setCurrentWhatsappStatus(status)),
        checkUserExists: val => dispatch(checkUserExists(val)),
        firstDealUserExists: val => dispatch(firstDealUserExists(val)),
        changeUserExistsValue: val => dispatch(changeUserExistsValue(val)),
        sendCampaignUserData: val => dispatch(sendCampaignUserData(val)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
